<template>
  <b-modal
    v-model="visible"
    dialog-class="setup-completed-modal"
    body-class="py-3"
    cancel-variant="secondary"
    centered
    hide-footer
    hide-header
    hide-header-close
    lazy
    no-close-on-backdrop
  >
    <div class="d-flex">
      <div class="pr-1 text-center">
        <feather-icon
          icon="CheckCircleIcon"
          size="36"
          class="text-success"
        />
      </div>
      <div>
        <div class="text-large font-weight-bold mb-1 text-secondary">
          {{ allCompleted ? $t('dashboard.wizard-completed-title') : $t('dashboard.wizard-basic-completed-title') }}
        </div>
        <div class="description-text font-weight-semi-bold">
          {{ allCompleted ? $t('dashboard.wizard-completed-description') : $t('dashboard.wizard-basic-completed-description') }}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <template v-if="visible === allCompleted">
        <b-button
          v-if="shouldAddBranch"
          variant="link"
        >
          <span
            class="text-secondary"
            @click="handleLater"
          >
            {{ $t('branch.add-new-branch') }}
          </span>
        </b-button>

        <b-button
          variant="success"
          @click="close"
        >
          {{ $t('dashboard.great') }}
        </b-button>
      </template>

      <template v-else>
        <b-button variant="link">
          <span
            class="text-secondary"
            @click="handleLater()"
          >
            {{ $t('dashboard.do-it-later') }}
          </span>
        </b-button>

        <b-button
          variant="success"
          @click="handleComplete"
        >
          {{ $t('dashboard.complete') }}
        </b-button>
      </template>

    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import PermissionMixin from '@/mixins/permission-mixin'

export default {
  name: 'SetupCompletedModal',
  components: { BModal, BButton },
  mixins: [PermissionMixin],
  computed: {
    visible: {
      get() { return this.$store.getters['setup/completedWizard'] },
      set(visible) { this.$store.commit('setup/SET_COMPLETED_MODAL', visible) },
    },
    allCompleted() {
      return this.$store.getters['setup/completed']
    },
    shouldAddBranch() {
      const numOfBranches = this.$store.getters['auth/user']?.num_of_branches || 0
      const branchesCount = this.$store.getters['branches/branches']?.length || 1

      return numOfBranches > branchesCount
    },
  },
  methods: {
    handleComplete() {
      this.visible = false
      this.$store.dispatch('setup/GET_FIRST_PENDING_WIZARD_ROUTE')
        .then(route => this.$router.push(route).catch(error => console.error(error)))
        .catch(error => this.$notifyError(error))
    },
    close() {
      this.visible = false
    },
    handleLater() {
      this.visible = false

      if (this.shouldAddBranch) {
        this.$store.commit('branches/SET_MULTI_BRANCHES_MODAL', this.isPrimaryAccount)
      }
    },
  },
}
</script>
